import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { AnimatedDashboard } from '../../../components/animation/AnimatedDashboard';
import { getUserTickets } from '../../../slices/auth-slice';
import { H3, P1 } from '../../../styles/FontStyles';
import { Box } from '../../../styles/GlobalComponents';
import { colors } from '../../../styles/GlobalStyles';
import { getAkashaHubs, getKriptoTapPackages } from '../Marketplace.actions';

import Spinner from '../../../components/common/Spinner';

import { Desktop } from '../../../App';
import BannerBitCoin from '../../../assets/images/backoffice/bitcoinBanners/BannerBitCoin.png';
import BannerBitCoinMobile from '../../../assets/images/backoffice/bitcoinBanners/BannerBitCoinMobile.png';
import bbc from '../../../assets/images/backoffice/bitcoinBanners/bbc.png';
import bbc1 from '../../../assets/images/backoffice/bitcoinBanners/bbc1.png';
import bbc2 from '../../../assets/images/backoffice/bitcoinBanners/bbc2.png';
import bbc3 from '../../../assets/images/backoffice/bitcoinBanners/bbc3.png';
import bbcv from '../../../assets/images/backoffice/bitcoinBanners/bbcv.png';
import { Mobile } from '../../Kyc/KycStyled';
import { AdvantagesGrid } from './KriptoTap.styled';
import { KriptoTapBuy } from './KriptoTapBuy';
import { PurchasePackageAndCombo } from '../PurchasePackageAndCombo/PurchasePackageAndCombo';

export const KriptoTap = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { loading, hubs } = useSelector((state) => state.marketplace);

  const firstHub = [hubs[0]];

  useEffect(() => {
    dispatch(getKriptoTapPackages());
    dispatch(getUserTickets());
  }, [dispatch]);

  const [selectedHub, setSelectedHub] = useState(hubs?.[0] || null);
  const [modal, setModal] = useState(false);

  const handleSeeDetails = (hub) => {
    setSelectedHub(hub);
  };

  const handleSelectPackage = (hub) => {
    setModal(true);
    handleSeeDetails(hub);
  };

  useEffect(() => {
    setSelectedHub(hubs?.[0]);
  }, [hubs]);

  const renderBanner = () => {
    return (
      <>
        <Desktop>
          <section style={{ position: 'relative' }}>
            <img
              src={BannerBitCoin}
              alt='trading'
              style={{ width: '100%', marginBottom: 20 }}
            />
          </section>
        </Desktop>

        <Mobile>
          <section style={{ position: 'relative' }}>
            <img
              src={BannerBitCoinMobile}
              alt='trading'
              style={{ width: '100%', marginBottom: 20 }}
            />
          </section>
        </Mobile>
      </>
    );
  };

  if (loading) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom key={'marketplace'}>
      <Box dark p='60px 80px' mt='20' pSM='padding: 40px 40px'>
        <H3 color={colors.primary900} mb='22'>
          KryptoTap Card
        </H3>
        <P1 color={colors.neutral0}>
          KryptoTap is a one-of-a-kind ecosystem offering unrestricted spending
          power to crypto users globally. With seamless crypto-to-USD
          conversion, KryptoTap loads funds onto a No-limit Card, enabling
          members to make purchases worldwide—whether for everyday essentials or
          luxury goods.
          <br />
          It's the only product on the market that empowers crypto users to
          spend their assets freely, without limits.
        </P1>
      </Box>

      {hubs.map((kriptoTapPackage, i) => (
        <KriptoTapBuy
          kriptoTapPackage={kriptoTapPackage}
          key={i}
          handleSelectPackage={handleSelectPackage}
        />
      ))}

      {renderBanner()}

      <AdvantagesGrid>
        <div>
          <img src={bbc1} style={{ width: '100%' }} />
        </div>
        <div>
          <img src={bbc2} style={{ width: '100%' }} />
        </div>
        <div>
          <img src={bbc3} style={{ width: '100%' }} />
        </div>
      </AdvantagesGrid>

      <PurchasePackageAndCombo
        selectedPackage={selectedHub}
        modal={modal}
        setModal={setModal}
      />
    </AnimatedDashboard>
  );
};

const cardsDummy = [
  { name: 'KryptoTap Physical Card', price: 299, image: bbc },
  { name: 'KryptoTap Virtual Card', price: 49, image: bbcv }
];
